import { Stack } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useRef, useState } from 'react';

import { StyledScrollWrapper } from '$/components/common/StyledScrollWrapper';
import { BackToTopButton } from '$/pages/DashboardPages/components/BackToTopButton';
import { ProjectModal } from '$/pages/DashboardPages/pages/Projects/components/ProjectModal';
import { useProjectModal } from '$/pages/DashboardPages/pages/Projects/hooks/useProjectModal';
import { ProjectFolderView } from '$/pages/SchoolClassPage/components/ProjectFolderView';
import { ProjectOverview } from '$/pages/SchoolClassPage/components/ProjectOverview';
import { SchoolClassRoute } from '$/routes/School/SchoolClassRoute';
import { schoolClassProjectsQuery } from '$/services/usecases/school/queries';

export const SchoolClassPage = () => {
  const { id } = SchoolClassRoute.useParams();
  const ref = useRef<HTMLDivElement>(null);
  const { data, isLoading, refetch } = useQuery(schoolClassProjectsQuery(id));
  const [selectedFolderId, setSelectedFolderId] = useState<string | null>(null);
  const isProjectModalOpen = useProjectModal.useIsOpen();

  useEffect(() => {
    if (!isProjectModalOpen) {
      void refetch();
    }
  }, [isProjectModalOpen, refetch]);

  if (isLoading || data == null) return null;

  const projects = data.response.projects ?? [];
  const folders = data.response.folders ?? [];
  const schoolClass = data.response.schoolClass;

  const shownProjects = projects.filter(
    (project) =>
      (selectedFolderId === null && project.parentId == null) ||
      project.parentId === selectedFolderId,
  );

  const selectedFolder = folders.find(
    (folder) => folder.id === selectedFolderId,
  );

  return (
    <Stack ref={ref} layerStyle='DashboardSection' w='full'>
      <StyledScrollWrapper>
        {selectedFolder != null ? (
          <ProjectFolderView
            projects={shownProjects}
            folder={selectedFolder}
            setSelectedFolderId={setSelectedFolderId}
          />
        ) : (
          <ProjectOverview
            projects={shownProjects}
            folders={folders}
            setSelectedFolderId={setSelectedFolderId}
            schoolClass={schoolClass}
          />
        )}

        <BackToTopButton containerRef={ref} right='65px' bottom='65px' />
      </StyledScrollWrapper>
      <ProjectModal />
    </Stack>
  );
};
